import React from 'react'
import './index.css'

const PushServiceItem: React.FC<{}> = (props) => {
    return <div className='pushServiceItem'>{props.children}</div>
}

export default React.memo<React.FC<{}>>(PushServiceItem)
